import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/squarespace': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M186.1 343.3C176.5 353 176.5 368.6 186.1 378.3 195.8 387.9 211.4 387.9 221.1 378.3L378.2 221.1C397.5 201.8 428.8 201.8 448.1 221.1S467.4 271.7 448.1 291L293.9 445.1C313.2 464.4 344.5 464.4 363.8 445.1L363.8 445.1 483.1 325.9C521.6 287.3 521.6 224.7 483.1 186.1 444.5 147.6 381.9 147.6 343.3 186.1L186.1 343.3zM430.6 238.5C421 228.9 405.4 228.9 395.7 238.5L238.5 395.7C219.3 415 188 415 168.7 395.8L168.7 395.7C159 386.1 143.4 386.1 133.7 395.7L133.7 395.7C124.1 405.4 124.1 421 133.7 430.6L133.7 430.7C172.3 469.2 234.9 469.2 273.4 430.7L430.6 273.5C440.3 263.8 440.3 248.2 430.6 238.5zM168.7 325.9L325.8 168.7C335.5 159 335.5 143.4 325.8 133.7 316.2 124.1 300.6 124.1 290.9 133.7L133.7 290.9C114.4 310.2 83.2 310.2 63.9 290.9L63.9 290.9C44.6 271.6 44.5 240.4 63.8 221.1L63.9 221.1 218 66.9C198.8 47.6 167.5 47.6 148.2 66.9L148.2 66.9 28.9 186.1C-9.7 224.7-9.7 287.3 28.9 325.9 67.5 364.4 130.1 364.4 168.7 325.9zM81.3 273.5C91 283.1 106.6 283.1 116.2 273.5L273.4 116.3C292.7 97 324 97 343.3 116.3L343.3 116.3C353 125.9 368.6 125.9 378.2 116.3 387.9 106.6 387.9 91 378.2 81.3 339.6 42.8 277.1 42.8 238.5 81.3L81.3 238.5C71.7 248.2 71.7 263.8 81.3 273.5H81.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/squarespace.js
// module id = bMQI
// module chunks = 144